"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledAddress = _styledComponents["default"].address(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.primaryFaded;
});
var Address = function Address(_ref2) {
  var _ref2$address = _ref2.address,
    firstName = _ref2$address.firstName,
    lastName = _ref2$address.lastName,
    company = _ref2$address.company,
    streetAndNumber = _ref2$address.streetAndNumber,
    apartmentNumber = _ref2$address.apartmentNumber,
    zip = _ref2$address.zip,
    city = _ref2$address.city,
    phoneNumber = _ref2$address.phoneNumber;
  return /*#__PURE__*/_react["default"].createElement(StyledAddress, null, "".concat(firstName || '', " ").concat(lastName || '').trim() || company, /*#__PURE__*/_react["default"].createElement("br", null), streetAndNumber, /*#__PURE__*/_react["default"].createElement("br", null), apartmentNumber && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, "Apt. \u2116 ", apartmentNumber, /*#__PURE__*/_react["default"].createElement("br", null)), "".concat(zip, " ").concat(city), /*#__PURE__*/_react["default"].createElement("br", null), phoneNumber ? /*#__PURE__*/_react["default"].createElement("span", null, "T: ", phoneNumber) : /*#__PURE__*/_react["default"].createElement("span", null, "\xA0"));
};
Address.propTypes = {
  address: (0, _propTypes.shape)({
    firstName: _propTypes.string,
    lastName: _propTypes.string,
    streetAndNumber: _propTypes.string,
    apartmentNumber: _propTypes.string,
    zip: _propTypes.string,
    city: _propTypes.string,
    phoneNumber: _propTypes.string
  }).isRequired
};
var _default = exports["default"] = Address;


//////////////////
// WEBPACK FOOTER
// ./node_modules/abihome-components/build/components/Address/index.js
// module id = 344
// module chunks = 17